import Chart from 'chart.js'
// import 'chartjs-plugin-labels'

export const LineChart = () => {
  const chart = document.getElementById('line-chart')
  if (!chart) return
  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels').split(',')
  var myChart = new Chart(ctx, {
    type: 'line',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        data: data,
        borderColor: '#4b2a81',
        pointBackgroundColor: 'rgba(75,42,129,0.5)',
        pointBorderColor: '#4b2a81',
        backgroundColor: 'transparent',
        borderWidth: 2,
        borderJoinStyle: 'round',
        borderCapStyle: 'square'
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            offsetGridLines: true,
            zeroLineColor: "#4b2982"
          }
        }],
        xAxes: [{
          gridLines: {
            display: true,
          }
        }],
      },
      legend: {
        display: false,
      }
    }
  })
}

export const Carriers = () => {
  const chart = document.getElementById('carriers')
  if (!chart) return
  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels')
  const upperCaseLabels = labels.split(',')

  for (let i = 0; i < upperCaseLabels.length; i ++){
    upperCaseLabels[i] = upperCaseLabels[i][0].toUpperCase() + upperCaseLabels[i].slice(1);
  }
  Chart.defaults.global.legend.display = false;
  Chart.defaults.doughnut.cutoutPercentage = 70;
  var myChart = new Chart(ctx, {
    type: 'pie',
    responsive: true,
    data: {
      labels: upperCaseLabels,
      datasets: [{
        data: data,
        backgroundColor: [
          '#4b2a81',
          '#979797',
          '#e45621',
          '#4EC1BA',
          '#937fb4',
        ],
        borderWidth: 0
      }]
    },
    options: {
      responsive:true
    }
  })


}

export const Costs = () => {
  const chart = document.getElementById('barcosts')
  if(!chart) return
  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels')
  const upperCaseLabels = labels.split(',')

  for (let i = 0; i < upperCaseLabels.length; i ++){
    upperCaseLabels[i] = upperCaseLabels[i][0].toUpperCase() + upperCaseLabels[i].slice(1);
  }
  Chart.defaults.global.legend.display = false;
  // Chart.defaults.global.legend.display = false;
  // Chart.defaults.doughnut.cutoutPercentage = 70;
  var myChart = new Chart(ctx, {
    type: 'bar',
    responsive: true,
    data: {
      labels: upperCaseLabels,
      datasets: [{
         data: data,
        //data: [10, 20, 30, 40, 50, 60, 70],
        backgroundColor: [
          '#4b2a81',
          '#979797',
          '#e45621',
          '#4EC1BA',
          '#937fb4',
          '#4b2a81',
          '#979797',
          '#e45621',
        ],
        // borderWidth: 0
        barPercentage: 0.5,
        // barThickness: 6,
        // maxBarThickness: 8,
        minBarLength: 2,
      }]
    },
    options: {
      responsive:true
    }
  })

}

